import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const { lang } = useParams<{ lang: string }>()

  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${lang ?? 'it'}/login`} replace />
  }

  return <>{children}</>
}
